import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class ProductSourceController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      // infinite: true,
      pagination: EnumAPI.content_resource_center_list,
      details: EnumAPI.content_resource_center_article,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'data',
          total: 'total',
        },
      },
    });
  }

  ListController = new BasesController({
    dataKey: 'id',
    // infinite: true,
    details: EnumAPI.content_resource_center_details,
  });

  /**
   * 值存储
   * @memberof ProductSourceController
   */
  Model = new BaseModel({ type: 'object' });

  /**
   * @dec 内容中心列表页 获取接口loading
   */
  @computed
  get seriesLoading(): Array<any> {
    return this.Model.get('seriesLoading', false);
  }
  /**
   * @dec 内容中心列表页 接口获取原始数据
   */
  @computed
  get sourceList(): Array<any> {
    return this.Model.get('sourceList', []);
  }
  /**
   * @dec 内容中心列表页 展示数据
   */
  @computed
  get productSourceList(): Array<any> {
    return this.Model.get('productSourceList', []);
  }
  /**
   * @dec 内容中心 筛选-banner背景图
   */
  @computed
  get productSourceBanner(): Array<any> {
    return this.Model.get('productSourceBanner', {});
  }
  /**
   * @dec 内容中心 筛选-系列
   */
  @computed
  get seriesOptions(): Array<any> {
    return this.Model.get('seriesOptions', []);
  }
  /**
   * @dec 内容中心 筛选-其他
   */
  @computed
  get otherOptions(): Array<any> {
    return [
      { label: '新品上市', value: 'hasNew' },
      { label: '包含视频', value: 'hasVideo' },
    ];
  }
  /**
   * @dec 内容中心 筛选条件-缓存
   */
  @computed
  get searchQuery(): any {
    return this.Model.get('searchQuery', {});
  }
  /**
   * @dec 内容中心 特赞token
   */
  @computed
  get tezignToken(): any {
    return this.Model.get('tezignToken', {});
  }

  /**
   * 内容中心详情数据
   */
  @computed
  get dataSource() {
    return this.Pagination.dataSource;
  }
  /**
   * 已勾选的内容中心
   */
  @computed
  get dataSourceSelected() {
    return lodash.filter(this.dataSource, (item: any) =>
      lodash.some(this.Pagination.selectedRowKeys, (key) =>
        lodash.eq(key, item.id),
      ),
    );
  }
  /**
   * 获取 内容中心筛选条件 系列
   */
  async getProductSourceBanner() {
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.content_resource_banner,
      });
      this.Model.merge({ productSourceBanner: lodash.head(res) });
    } catch (error) {}
  }
  /**
   * 获取 内容中心筛选条件 系列
   */
  async getProductSourceSerial() {
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.content_resource_serial,
      });
      const result = lodash.map(res, (item) => {
        return {
          label: item.name,
          value: item.key,
        };
      });
      this.Model.merge({ seriesOptions: result });
    } catch (error) {}
  }
  /**
   * 获取 内容中心列表 list
   */
  async getProductSourceList(query?: { keywords: String }) {
    this.Model.merge({ seriesLoading: true });
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.content_resource_list,
        body: query,
        // cache: true,
      });
      const result = lodash.map(res, (item) => {
        return {
          label: item.name,
          value: item.key,
        };
      });
      this.Model.merge({
        seriesOptions: result,
        sourceList: res,
        productSourceList: res,
        seriesLoading: false,
      });
    } catch (error) {
      this.Model.merge({ seriesLoading: false });
    }
  }
  /**
   * 筛选 内容中心
   */
  filterProductSource(query) {
    this.Model.merge({ searchQuery: lodash.assign(this.searchQuery, query) });
    const { keyWord, series, other } = this.searchQuery;
    const list = lodash.cloneDeep(this.sourceList);
    let result = list;
    // 系列
    if (!lodash.isEmpty(series)) {
      result = lodash.filter(list, (item) => {
        return lodash.indexOf(series, item.key) >= 0;
      });
    }
    // 关键字
    if (keyWord) {
      const data = lodash.cloneDeep(result);
      result = lodash.map(data, (item) => {
        item.products = lodash.filter(item.products, (nitem) => {
          return lodash.includes(
            lodash.get(nitem, 'ntitle').toLowerCase(),
            keyWord.toLowerCase(),
          );
        });
        return item;
      });
    }
    // 其他
    if (!lodash.isEmpty(other)) {
      const data = lodash.cloneDeep(result);
      result = lodash.map(data, (item) => {
        item.products = lodash.filter(item.products, (nitem) => {
          let flagArr: Array<Boolean> = [];
          lodash.forEach(other, (oitem) => {
            flagArr.push(lodash.get(nitem, oitem));
          });
          const flag = lodash.every(flagArr);
          return flag;
        });
        return item;
      });
    }
    this.Model.merge({ productSourceList: result });
  }
  /**
   * 内容中心 详情 单选 全选
   * @param toggle
   * @returns
   */
  toggleChecked(toggle) {
    let selectedRowKeys = [...this.Pagination.selectedRowKeys];
    if (lodash.isBoolean(toggle)) {
      // 全选
      if (lodash.eq(toggle, true)) {
        selectedRowKeys = lodash.map(this.dataSource, 'id');
      } else {
        selectedRowKeys = [];
      }
    } else {
      const { id } = toggle;
      // 反选
      if (this.isChecked(toggle)) {
        lodash.remove(selectedRowKeys, (item) => lodash.eq(item, id));
      } else {
        selectedRowKeys.push(id);
      }
    }
    this.Pagination.onSelectChange(selectedRowKeys);
  }
  /**
   * 当前内容中心是否选中
   * @param entity
   * @returns
   */
  isChecked(entity) {
    return lodash.includes(this.Pagination.selectedRowKeys, entity.id);
  }
  /**
   * 内容中心 详情 全选
   * @returns
   */
  isCheckedAll() {
    const selectedSize = lodash.size(this.Pagination.selectedRowKeys);
    if (selectedSize) {
      return lodash.eq(selectedSize, lodash.size(this.dataSource));
    }
  }
  event_type_code = {
    down: 'Portal_Content_Download',
    view: 'Portal_Content_View',
    share: 'Portal_Content_Share',
  };

  //埋点
  tezignPoint({ portalId, blockId, id, assetId, type, cordId }) {
    try {
      window.tezignExternalTrack.track({
        event_type_code: lodash.get(this.event_type_code, type),
        event_properties: {
          data_source: 'external_sdk',
          portal_id: portalId,
          block_id: blockId,
          content_id: id,
          asset_id: cordId,
        },
      });
    } catch (err) {
      console.log('err', err);
    }
  }
  /**
   * 获取 内容中心 特赞token
   */
  async getTezignToken() {
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.content_resource_tezign_token,
      });
      this.Model.merge({ tezignToken: lodash.get(res, 'access_token') });
    } catch (error) {}
  }
}
